import React, {useEffect, useState} from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle, Typography,
} from '@material-ui/core';
import {createUniqueId} from '../../helpers/createUniqueId';
import {Beer, Brewery} from '../../models';
import BeerEdit from './BeerEdit';
import PlaceEdit from '../Place/PlaceEdit';


interface Props {
  beer?: Beer | null,
  brewery?: Brewery | null,
  onClose?: (value: string) => void,
  open?: boolean,
}


const BeerEditDialog = ({open=false, ...props}: Props) => {

  const {beer, brewery, onClose} = props;

  const [formId, setFormId] = useState<string>("beerForm");
  useEffect(() => {
    setFormId(createUniqueId());
  }, []);

  const [error, setError] = useState<string|null>(null);
  const handleError = (message: string) => {
    setError(message);
  };

  const handleClose = () => {
    onClose && onClose('Closed');
  };

  return (
    <div>
      <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="beer-edit-dialog-title"
      >
        <DialogTitle id="beer-edit-dialog-title">
          Edit Beer
        </DialogTitle>
        <DialogContent>
          <BeerEdit
            beer={beer}
            brewery={brewery}
            formId={formId}
            onComplete={handleClose}
            onError={handleError}
            hideButtons
            hideError
          />
        </DialogContent>
        <DialogActions>
          {error &&
            <Typography variant="body1" color="error">
              {error}
            </Typography>
          }
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
              color="primary"
              type="submit"
              form={formId}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BeerEditDialog;
